import Vue from 'vue'
// 引入根组件
import App from './App'
// 引入路由
import router from './router'
// 引入vuex配置
import store from './store'
// 全局css样式
import '@/components/styles/common.css'
// router的配置
import './permission'
// 引入element-ui插件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 处理标签title
import VueWechatTitle from 'vue-wechat-title'
// 全局引入工具类
import Utils from '@/utils/utils.js'
// 全局常量
import Constant from '@/api/constant.js'
// ajax
import request from '@/utils/request'
// swiper
import '../node_modules/swiper/dist/css/swiper.css'

import Vant from "vant";
Vue.use(Vant);
import {Dialog} from 'vant';
import 'vant/lib/index.css';

/** 引入echarts */
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad)


import Loading from '@/components/loading/loading.js'
Vue.use(Loading)

//filters
import filters from './utils/globalFilters' 

import '@/assets/iconfont/iconfont.css'

/* 全局注册过滤器 */
Object.keys(filters).forEach(item => Vue.filter(item,filters[item]))

Vue.use(ElementUI)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.prototype.$vDialog = Dialog
Vue.prototype.$utils = Utils
Vue.prototype.$axios = request
Vue.prototype.$constant = Constant

Vue.prototype.goAnchor = (lisecond) => {
  var anchor = document.documentElement.querySelector('lisecond')
  document.body.scrollTop = anchor.offsetTop
  document.documentElement.scrollTop = anchor.offsetTop
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js